<script>
	import { PRConnect } from "@projectroom/ui-lib";
	import { onMount } from 'svelte';
	import axios from "axios";
	import EmojiSelector from 'svelte-emoji-selector';
	import 'suneditor/dist/css/suneditor.min.css';
  	import suneditor from 'suneditor';
	import plugins from 'suneditor/src/plugins';
	import lang from 'suneditor/src/lang';
  	import { ko } from 'suneditor/src/lang';

	export let event;

	const refEditor = {
		content: {},
		notice: {}
	};
	let refMainImageContent, refTitle, refSubTitle;

	$: if (event.currentTab === "eventInfo" && event.isLoad && Object.keys(refEditor.content).length === 0) {
		setEditor("content", "event-content", event.content);
		setEditor("notice", "event-notice", event.notice);
	}
	onMount(() => {
	});

	const setEditor = (refTarget, targetId, content) => {
		let editor;
		editor = suneditor.create(targetId);
		editor.setDefaultStyle('font: Notosanskr; font-size: 10px;');
		editor.setOptions({
		defaultStyle: "font-size:14px;font-family: Notosanskr, sans-serif;font-weight:400;",
		minHeight: '300px',
		width: "100%",
		plugins: plugins,
		placeholder: "상세정보를 입력해주세요. (사진첨부 가능)",
		showPathLabel: false,
		lang: lang.ko,
		buttonList: [
			['undo', 'redo'],
			['fontSize',],
			['bold', 'underline'],
			['fontColor', 'removeFormat'],

			['horizontalRule', 'list',],
			['link', 'image'],
			['fullScreen', 'preview'],
		]

		});
		editor.setContents(content);
		editor.onImageUpload = async (targetElement, index, state, info, remainingFilesCount, core) => {
            let fileSrc;
            let fileType;
            try {
                fileSrc = info.src;
                fileType = info.src.split("data:")[1].split(";")[0];
            } catch {
                console.log("stored image load error");
                return;
            }
            targetElement.src = `https://groovworks-avatalk-public-file-storage.s3.ap-northeast-2.amazonaws.com/common/event/${event.id}/detail/${info.name}`;
            const res = await fetch(fileSrc);
            const blob = await res.blob();
            const uploadFile = new File([blob], info.name, { type: fileType });
			uploadFileForFileStorage(uploadFile, editor);
		};
		refEditor[refTarget] = editor;
	}

	const uploadFileForFileStorage = (file, editor) => {
		let image = file;
        const key = `common/event/${event.id}/detail/${image.name}`;
		const type = image.type;
        PRConnect.send("/api/File/uploadPresignedUrl", {key, type}, data => {
            axios.put(data.result, image, {headers: {"Content-Type": type}})
            .then( response =>{
				if (editor === mainEditor) {
					event.changeContent(editor.getContents());
				} else {
					event.changeNotice(editor.getContents());
				}
            });
        });  
    }

	const onMainImageContentFileUpload = (e) => {
        let image = e.target.files[0];
        const key = `common/event/${event.id}/detail/${image.name}`;
		const type = image.type;
        PRConnect.send("/api/File/uploadPresignedUrl", {key, type}, data => {
            axios.put(data.result, image, {headers: {"Content-Type": type}})
            .then( response =>{
                event.changeMainImageContent(image.name);
				event = event;
            }).catch(error => {
				console.log("upload fail");
			});
        });  
    }

	const clickMainImageDelete = () => {
		event.deleteMainImageContent();
	}


	const onEmoji = (e, type) => {
        if (type == "SUB") {
            changeSubTitle(e.detail);
        } else {
            changeTitle(e.detail);
        }
    }

	const changeTitle = (addedContext = "") => {
        const title = refTitle.value.slice(0, refTitle.selectionEnd) + addedContext + refTitle.value.slice(refTitle.selectionEnd);
		event.changeTitle(title);
    }
    const changeSubTitle = (addedContext = "") => {
        const subTitle = refSubTitle.value.slice(0, refSubTitle.selectionEnd) + addedContext + refSubTitle.value.slice(refSubTitle.selectionEnd);
        event.changeSubTitle(subTitle);
    }

	const onMouseLeave = (editor) => {
		if (editor === "content") {
			event.changeContent(refEditor[editor].getContents());
		} else {
			event.changeNotice(refEditor[editor].getContents());
		}
	}
</script>

<div data-w-tab="Tab 2" class="tab-pane-tab-2 w-tab-pane" class:w--tab-active={event.currentTab === "eventInfo"} id="event-info">
	{#if event.isLoad}
	<div class="event-thumbnail-write-wrap">
		<div class="event-write">
			<div class="admin-title-text _2">이벤트 정보 작성</div>
			<div class="event-main-text">
				<div class="admin-title-text">메인 텍스트</div>
				<div class="linktext-block-form">
				<div class="text-block-94">타이틀 텍스트</div>
				<div class="linktext-input-form-copy w-form">
					<div id="email-form" name="email-form" data-name="Email Form" method="get" class="link-form admin" aria-label="Email Form">
						<input type="text" class="name-text-form w-input" bind:this={refTitle} autofocus="true" value={event.title} maxlength="256" name="name-4" data-name="Name 4" placeholder="ex) 메인 타이틀" on:change={()=>changeTitle()}>
						<EmojiSelector on:emoji={onEmoji} />
					</div>
				</div>
				</div>
				<div class="linktext-block-form">
				<div class="text-block-94">서브 텍스트</div>
				<div class="linktext-input-form-copy w-form">
					<div id="email-form" name="email-form" data-name="Email Form" method="get" class="link-form admin" aria-label="Email Form">
						<input type="text" class="name-text-form w-input" bind:this={refSubTitle} autofocus="true" value={event.subTitle} maxlength="256" name="name-4" data-name="Name 4" placeholder="ex) 메인 서브 타이틀" on:change={()=>changeSubTitle()}>
						<EmojiSelector on:emoji={(e)=>onEmoji(e,"SUB")} />
					</div>
				</div>
				</div>
			</div>
			<div class="event-main-image">
				<div class="admin-title-text">메인 이미지</div>
				<div class="event-thumbnail-image">
					{#if event.getMainImageContent()}
						<img class="main-image-content" src={event.getMainImageContent()} />
						<img loading="lazy" src="/static/images/trashcan-icon.svg" class="logo-image-delete" on:click={clickMainImageDelete}>
					{:else}
						<img src="https://uploads-ssl.webflow.com/6305dccb2939dad9c631e36f/64b7852fd75bbfcf43e8d2b1_upload-icon-big.svg" loading="lazy" alt="" class="image-153">
						<div>
							<a href="#" class="image-upload-button w-button" on:click={refMainImageContent.click()}>메인 이미지 업로드</a>
				<input accept="image/png, image/jpeg, image/jpg" bind:this={refMainImageContent} type="file" name="add" on:change={onMainImageContentFileUpload} hidden>
						</div>
					{/if}
					
				</div>
			</div>
			<div class="event-infomation-text">
				<div class="admin-title-text">이벤트 안내 텍스트</div>
				<div class="linktext-block-form">
				<div class="text-block-94">이벤트 관련 안내글</div>
				<div class="linktext-input-form-copy w-form" on:mouseleave={()=> onMouseLeave("content")}>
					<div id="email-form" name="email-form" data-name="Email Form" method="get" class="contents-con">
						<textarea id="event-content"></textarea>
					</div>
				</div>
				</div>
			</div>
			<div class="event-note-text">
				<div class="admin-title-text">유의사항 텍스트</div>
				<div class="linktext-block-form">
				<div class="text-block-94">유의사항 관련 안내글</div>
				<div class="linktext-input-form-copy w-form" on:mouseleave={()=> onMouseLeave("notice")}>
					<div id="email-form" name="email-form" data-name="Email Form" method="get" class="contents-con">
						<textarea id="event-notice"></textarea>
					</div>
				</div>
				</div>
			</div>
		</div>
	</div>
	{/if}
</div>
<style>

	.event-thumbnail-image {
		position: relative;
	}

	.main-image-content {
		width: 300px;
		border-radius: 10px;
		height: -webkit-fill-available;
	}

	.logo-image-delete {
		right: 15px;
		top: 15px;
		position: absolute;
		cursor: pointer;
	}

	.image-153 {
		margin-top: 0px;
		margin-left: 0px;
	}

	.link-form {
		position: relative;
	}

	.name-text-form {
		width: 100%;
	}

	.contents-con {
		overflow: scroll;
		max-height: 800px;
	}

</style>